import React,{useEffect, useState} from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Link,useParams,useNavigate } from "react-router-dom";
// import { clearErrors, createCategory } from "../../actions/categoryAction";
import { useAlert } from "react-alert";
import { Button } from "@material-ui/core";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import DescriptionIcon from "@material-ui/icons/Description";
import StorageIcon from "@material-ui/icons/Storage";
import SpellcheckIcon from "@material-ui/icons/Spellcheck";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import MetaData from '../../components/MetaData';
import Loader from "../Loader";
import Sidebar from "./Sidebar";
import { clearErrors, banner } from "../../actions/userAction";
import { UPLOAD_BANNER_RESET } from "../../constants/userConstant";
import { Editor } from '@tinymce/tinymce-react';

const AddBanner = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const alert = useAlert();

	const { loading, error, success } = useSelector((state) => state.newbanner);

	const [name, setName] = useState("");
	const [status, setStatus] = useState("");
	const [description, setDescription] = useState("");
	const [images, setImages] = useState([]);
	const [imagesPreview, setImagesPreview] = useState([]);

	const handleEditorChange = (content) => {
	    setDescription(content);
	};

	// const categories = [
	//   "wall-tiles",
	//   "floor-tiles",
	//   "bathroom-tiles",
	//   "outdoor-tiles",
	//   "brick-&-metro tiles",
	//   "mosaic-tiles",
	// ];

	// console.log(images);

	useEffect(() => {
	    if (error) {
	      alert.error(error);
	      dispatch(clearErrors());
	    }

	    if (success) {
	      alert.success("Banner Created Successfully");
	      navigate("/admin/banner-list");
	      dispatch({ type: UPLOAD_BANNER_RESET });
	    }
	}, [dispatch, alert, error, navigate, success]);

	const createBannerSubmitHandler = (e) => {
	    e.preventDefault();

	    const myForm = new FormData();

	    for (let i = 0; i < images.length; i++) {
          myForm.append('images', images[i]);
        }

	    myForm.set("name", name);
	    myForm.set("status", status);
	    myForm.set("description", description);
	    // images.forEach((image) => {
	    //   myForm.append("images", image);
	    // });

	    dispatch(banner(myForm));
	    // console.log(myForm)
	};
	
	const createBannerImagesChange = (e) => {
	    // const files = Array.from(e.target.files);

	    // setImages([]);
	    // setImagesPreview([]);

	    // files.forEach((file) => {
	    //   const reader = new FileReader();

	    //   reader.onload = () => {
	    //     if (reader.readyState === 2) {
	    //       setImagesPreview((old) => [...old, reader.result]);
	    //       setImages((old) => [...old, reader.result]);
	    //     }
	    //   };

	    //   reader.readAsDataURL(file);
	    // });
	    const fileList = e.target.files;
        setImages(fileList);
	};

	
	return (
		<>
			{loading ? (
        <Loader />
      ) : (
      	<>

		      		<div className="dashboard-panel">
					<div className="container">
						<MetaData title={`Create Banner`} />
						<div className="row">
							<Sidebar />	
							<div className="col-lg-9 col-md-8">
								<div className="dashboardContainer">
							        <h3>Create Banner</h3>
							        <div className="col-12">
		                    			<form
							            className="createProductForm"
							            encType="multipart/form-data"
							            onSubmit={createBannerSubmitHandler}
							          >
							            <div className="single-form">
							              <label>Banner Name</label>
							              <input
							                type="text"
							                placeholder="Banner Name"
							                required
							                value={name}
							                onChange={(e) => setName(e.target.value)}
							              />
							            </div>
							            
							            <div className="single-form">
							              <label>Banner Status</label>
							              <select onChange={(e) => setStatus(e.target.value)}>
							                <option value="">Choose Status</option>
							                <option value="show">Show</option>
							                <option value="hide">Hide</option>
							              </select>
							            </div>
							            

							            <div className="single-form">
							              <label>Banner Description</label>
							              {/*<textarea
							                placeholder="Banner Description"
							                value={description}
							                onChange={(e) => setDescription(e.target.value)}
							                cols="10"
							                rows="1"
							              ></textarea>*/}
							              <Editor 
							              	apiKey='511npkfmj2oio25sykoybbl32gny8yfwq0zbl3m5zrkzqoz7'
							              	init={{
												height: 500,
												menubar: true,
												plugins: [
													'advlist autolink lists link image charmap print preview anchor',
													'searchreplace visualblocks code fullscreen',
													'insertdatetime media table paste code help wordcount'
												],
												toolbar:
													'undo redo | formatselect | bold italic backcolor | \
				                                    alignleft aligncenter alignright alignjustify | \
				                                    bullist numlist outdent indent | removeformat | help',
				                                    image_uploadtab: true,
											        image_advtab: true, // Enable advanced tab for images
											        file_picker_types: 'image',
											        automatic_uploads: true,
											}}
											onEditorChange={handleEditorChange}
							              />							              	
							            </div>

							            <div className="single-form" id="createProductFormFile">
							            	<label>
							              	Banner Image
							              </label>
							              <input
							                type="file"
							                accept="image/*"
							                onChange={createBannerImagesChange}
							                multiple={true}
							              />
							            </div>

							            <div className="single-form" id="createCateFormImage">
							              {imagesPreview.map((image, index) => (
							                <img key={index} src={image} alt="Banner Preview" />
							              ))}
							            </div>

							            <button
							            className="mt-2 btn btn-primary btn-hover-dark paymentFormBtn"
							              id="createCateBtn"
							              type="submit"
							              disabled={loading ? true : false}
							            >
							              Create
							            </button>
							          </form>
		  						    </div>
							    </div>
							</div>
						</div>
					</div>
					</div>
</>
		)}
		      	
		</>
	)
}

export default AddBanner